import systemviewpage from "../../Images/system-view-page.png";
import leveltable from "../../Images/level detail table.jpg"; 

const MonitoringContent = () => {
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-3xl font-semibold text-blue-800 mb-6">
        MONITORING THE AGENT USING HIDS
      </h1>
      <b>Dashboard</b>
      <img src={systemviewpage} className="size-2/3" />

      <p>
        After successfully installing the agent and connecting it to the HIDS
        dashboard, your system's monitoring data will appear, as shown in the
        screenshot. Here's what you will typically see on the HIDS Dashboard:
      </p>
      <ol className="flex flex-col gap-4 list-disc ml-2">
        <li>
          <b>Alerts Summary: </b> A clear breakdown of different types of
          alerts, including:
        </li>
        <li className="ml-6 font-bold">
          Alerts Levels &gt; 10 (critical alerts)
        </li>
        <li className="ml-6 font-bold">Rootkit Alerts.</li>
        <li className="ml-6 font-bold">File Integrity Changes</li>
        <li className="ml-6 font-bold">Attack Alerts</li>
        <li>
          <b>Real-Time Graphs:</b>Visualizes the number of alerts or system
          events over time, allowing you to monitor spikes or patterns in
          security events.
        </li>
        <li>
          <b>Top Alert Groups:</b> Pie charts display the top categories of
          alerts, showing the alert group by type and log file, which helps you
          focus on the most critical or frequent threats.
        </li>
      </ol>

      <p>
        The table in the image provides information about active systems in a
        network, displaying details such as ID, Name, IP Address, Operating
        System, Status, and Last Seen Time.
      </p>
      <img src="" className="size-2/3" />
      <p>Explanation of Each Column:</p>
      <ul className="flex flex-col gap-4 list-disc ml-6">
        <li>
          <b>ID:</b> A unique identifier assigned to each system.
        </li>
        <li>
          <b>Name:</b> The hostname or identifier assigned to the system.
        </li>
        <li>
          <b>IP Address: </b> The network address (IPv4 or IPv6) assigned to the
          system.
        </li>
        <li>
          <b>Operating System:</b> The OS running on the system (Ubuntu or
          Windows in this case).
        </li>
        <li>
          <b>Status:</b> The current operational state of the system (all are
          marked active).
        </li>
        <li>
          <b>Last Seen:</b> The last recorded timestamp when the system was
          detected as online.
        </li>
      </ul>
      <img src="" className="size-2/3" />
      <p>
        <b>Groups:</b> The category or group to which the alert belongs.
      </p>
      <p>For Example:</p>
      <ul className="flex flex-col gap-4 list-disc ml-6">
        <li>
          <b>ossec:</b> Alerts related to OSSEC (Open Source HIDS).
        </li>
        <li>
          <b> web, accesslog, attack:</b> Related to web server events and
          potential attacks.
        </li>
      </ul>
      <p>
        This table provides a detailed view of the specific events happening in
        the system, helping administrators quickly identify and assess the
        severity of issues and take appropriate action.
      </p>
      <img src="" className="size-2/3" />
      <img src="" className="size-2/3" />
      <p>
        The displayed pie charts on the SecurWeave HIDS dashboard provide a
        detailed breakdown of security alerts.
      </p>
      <b>Top Alert Groups:</b>
      <p>This pie chart categorizes alerts based on their group, such as:</p>
      <ul className="flex flex-col gap-4 list-disc ml-6">
        <li>
          <b>web:</b>Indicating alerts related to web activity.
        </li>
        <li>
          <b> accesslog:</b> Alerts generated from access logs.
        </li>
        <li>
          <b>attack, nginx, recon, web_scan, ossec, and appsec:</b> Represent
          various other alert categories related to system security, web
          scanning, reconnaissance, or intrusion detection.
        </li>
        <li>
          The size of each segment reflects the volume of alerts in that
          category, helping you prioritize actions.
        </li>
      </ul>
      <b>Top Alert Groups by Log File:</b>
      <ul className="flex flex-col gap-4 list-disc ml-6">
        <li>
          This chart highlights the source log files contributing to the alerts:
        </li>
        <li className="ml-12">
          <b> /var/log/nginx/access.log and /var/log/nginx/error.log: :</b>{" "}
          Alerts generated from access logs.
        </li>
        <li className="ml-12">
          <b>logcollector:</b> Represent various other alert categories related
          to system security, web scanning, reconnaissance, or intrusion
          detection.
        </li>
        <li>
          This categorization aids in identifying which log files require closer
          examination for potential issues.
        </li>
      </ul>
      <p>
        The graph displayed on the SecurWeave HIDS dashboard represents the
        system activity over time for different monitored systems. Each line on
        the graph corresponds to a specific system, with different colour codes
      </p>
      <img src="" className="size-2/3" />
      <b>Heatmap:</b>
      <img src="" className="size-2/3" />
      <p>
        The image is a heatmap visualization of source IP addresses, indicating
        the geographical distribution of network activity. This is typically
        used in cybersecurity monitoring, threat intelligence, or network
        traffic analysis.
      </p>
    </div>
  );
};

export default MonitoringContent;
